const TOKEN_KEY = 'dalmuti.token';
const USER_KEY = 'dalmuti.user';

export interface SessionUser {
  id: string;
  username: string;
  rating: number;
  status: string; // "pending" | "approved" | "rejected"
  role: string; // "user" | "admin"
  email?: string;
  avatarUrl?: string | null;
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUser(): SessionUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as SessionUser;
  } catch {
    return null;
  }
}

export function setSession(token: string, user: SessionUser): void {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function setUser(user: SessionUser): void {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearSession(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function isAdmin(user: SessionUser | null = getUser()): boolean {
  return user?.role === 'admin';
}

export function isApproved(user: SessionUser | null = getUser()): boolean {
  return user?.status === 'approved';
}
